import { createFileRoute } from "@tanstack/react-router";

export {
	AssigneeTypeFilter,
	type AssigneeTypeFilter as AssigneeTypeFilterValue,
	JobAssigneesPanel as JobDrawerAssigneePanel,
} from "@/features/jobs/components/job-assignees-panel";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/_drawer/assignee",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
